import React from "react";
import Snackbar from '@material-ui/core/Snackbar';
import NextButton from "./NextButton";
import BackButton from "./BackButton";
import NavigationContainer from "./Stepper";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';

export default function MultistepWizard({ components, formState, stepState, isEdit, saveChangesState, onCancel, existsOnPlanner }: any) {
    const { bookingToast } = useSelector((state: RootState) => state.appState);
    const dispatch = useDispatch();

    const NextButtonWrapper = ({ onClick = () => console.log("Button Clicked.") }: any) => {
        return (
            <React.Fragment>
                <BackButton setActiveStep={stepState[1]}
                    firstStep={stepState[0] == 0}

                />
                <NextButton
                    setActiveStep={stepState[1]}
                    finalStep={stepState[0] == Object.keys(components).length - 1}
                    onClick={onClick}
                />
               
            </React.Fragment>
        );
    };

    const handleData = (data: object) => {
        formState[1]({ ...formState[0], ...data });
    }

    const Component = components[Object.keys(components)[stepState[0]]];
    return (
        <span style={{ display: "flex", flex: 1, overflow: "hidden", height: "100vh" }}>
            <div style={{ display: "flex", width: 260 }}>
                <NavigationContainer saveChangesState={saveChangesState} isEdit={isEdit} steps={Object.keys(components)} setActiveStep={stepState[1]} activeStep={stepState[0]} onCancel={onCancel} />
            </div>
            <div style={{ display: "flex", flex: 1, flexWrap: "wrap", height: "100vh", overflowY: "scroll", overflowX: "hidden", paddingLeft: 30, paddingRight: 30, boxSizing: "border-box", scrollbarWidth: "thin" }}>
                <Component
                    data={formState[0]}
                    handleData={handleData}
                    NextButton={NextButtonWrapper}
                    saveChangesState={saveChangesState}
                    isEdit={isEdit}
                    dispatch={dispatch}
                    existsOnPlanner={existsOnPlanner}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    open={bookingToast ? bookingToast.open : false}
                    message={bookingToast ? bookingToast.message : ""}
                />
            </div>
        </span>
    );
}
